<template>
  <v-form class='pqrAwsViewForm' v-model='valid' ref='pqrAwsViewForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <div class="logo_box text-center">
            <img :src="$getCompanyData().url" height="150" width="200" />
          </div>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <h4>Procedure Qualification Record</h4>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Procedure No</label>
          <p>{{ pqrAws.serial_no ? pqrAws.serial_no : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Company Name</label>
          <p>{{ pqrAws.company_name ? pqrAws.company_name : '-' }}</p>
          <label class='view_label'>Company Address</label>
          <p>{{ pqrAws.company_address ? pqrAws.company_address : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Refrerred Standard</label>
          <p><v-chip small>{{ pqrAws.referred_standard_name ? pqrAws.referred_standard_name  : '-' }}</v-chip></p>
          <label class='view_label'>Welding Process</label>
          <p><v-chip small v-for="(item, index) in pqrAws.wptwpr_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'  class="pt-0">
          <v-row>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev No</label>
              <p>{{ pqrAws.rev_no ? pqrAws.rev_no  : '-' }}</p>
            </v-col>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev Date</label>
              <p>{{ pqrAws.rev_date ? pqrAws.rev_date : '-' }}</p>
            </v-col>
          </v-row>
          <label class='view_label'>Welding Type</label>
          <p><v-chip small v-for="(item, index) in pqrAws.wptwt_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
      </v-row>
      <h4 class="text-center">Joint Design</h4><hr>
      <v-row>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Joint Design</label>
          <p>{{ pqrAws.joint_design ? pqrAws.joint_design  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="3" sm="6" xs="12">
          <label class='view_label'>Joint Backing</label>
          <p><template><v-chip :color="pqrAws.joint_backing == 0 ? 'warning' : 'success'" small>{{ pqrAws.joint_backing == 0 ? 'No' : 'Yes' }}</v-chip></template></p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Backing Material</label>
          <p>{{ pqrAws.joint_backing_material ? pqrAws.joint_backing_material  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Back Gouging</label>
          <p><template><v-chip :color="pqrAws.back_gouging == 0 ? 'warning' : 'success'" small>{{ pqrAws.back_gouging == 0 ? 'No' : 'Yes' }}</v-chip></template></p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Back Gouging Method</label>
          <p>{{ pqrAws.back_gouging_method ? pqrAws.back_gouging_method  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Joint Type</label>
          <p><v-chip small>{{ pqrAws.joint_type_name ? pqrAws.joint_type_name  : '-' }}</v-chip></p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Root Spacing</label>
          <p>{{ pqrAws.root_spacing ? pqrAws.root_spacing  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Root Face</label>
          <p>{{ pqrAws.root_face ? pqrAws.root_face  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Groove Angle</label>
          <p>{{ pqrAws.groove_angle ? pqrAws.groove_angle  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='3' sm='6' xs='12'>
          <label class='view_label'>Radius</label>
          <p>{{ pqrAws.radius ? pqrAws.radius  : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md="12" xs="12">
          <label class='view_label'>Joint Drawings</label>
          <div class="upload_container">
            <v-row>
              <v-col v-for="(image, i) in pqrAws.welding_procedure_drawing" :key="i" class="d-flex child-flex" cols="6">
                <div class="jointDrawings">
                  <v-row>
                    <v-col cols='12' md='5' sm='12' xs='12'>
                      <img height="150" width="200" :src="`${image.url}`" />
                    </v-col>
                    <v-col cols='12' md='7' sm='12' xs='12'>
                      <v-row>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>A : {{ image.param_a ? image.param_a : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>B : {{ image.param_b ? image.param_b : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>C : {{ image.param_c ? image.param_c : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>D : {{ image.param_d ? image.param_d : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>E : {{ image.param_e ? image.param_e : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>F : {{ image.param_f ? image.param_f : ''}}</p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="break_page">
        <h4 class="text-center">Base Metals</h4><hr>
        <v-row v-for="(bm, bmi) in pqrAws.base_metal" :key="bmi" class="pt-5">
          <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Base Metal</label>
                <p>{{ bm.base_metal ? bm.base_metal  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Name / Grade</label>
                <p>{{ bm.grade ? bm.grade  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Material Specification</label>
                <p>{{ bm.material_specification ? bm.material_specification  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>P No</label>
                <p>{{ bm.p_no ? bm.p_no  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Group No</label>
                <p>{{ bm.group_no ? bm.group_no  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Thickness</label>
                <p>{{ bm.thickness ? bm.thickness  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Groove Thickness Range</label>
                <p>{{ bm.groove_thickness_range ? bm.groove_thickness_range  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Fillet Thickness Range</label>
                <p>{{ bm.fillet_thickness_range ? bm.fillet_thickness_range  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Pipe Diameter Range</label>
                <p>{{ bm.pipe_diameter_range ? bm.pipe_diameter_range  : '-' }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Filler Metals</h4><hr>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>AWS Classification</label>
              <p>{{ pqrAws.aws_classification ? pqrAws.aws_classification  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Filler Metal Diameter</label>
              <p>{{ pqrAws.filler_metal_diameter ? pqrAws.filler_metal_diameter  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Manufacturer Trade Name</label>
              <p>{{ pqrAws.manufacturer_trade_name ? pqrAws.manufacturer_trade_name  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Other</label>
              <p>{{ pqrAws.filler_metal_other ? pqrAws.filler_metal_other  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Shielding</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12' class='radio-with-lable'>
              <label class='view_label'>Flux</label>
              <p><template><v-chip :color="pqrAws.flux == 0 ? 'warning' : 'success'" small>{{ pqrAws.flux == 0 ? 'No' : 'Yes' }}</v-chip></template></p>
            </v-col>
            <v-col :cols="colValue" md="8" sm="8" xs="12">
              <label class='view_label'>Electrode Flux (Class)</label>
              <p>{{ pqrAws.electrode_flux ? pqrAws.electrode_flux  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Gas + Composition %</label>
              <p>{{ pqrAws.composition_per ? pqrAws.composition_per  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Flow Rate</label>
              <p>{{ pqrAws.flow_rate ? pqrAws.flow_rate  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Nozzle Size</label>
              <p>{{ pqrAws.nozzle_size ? pqrAws.nozzle_size  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Positions</h4><hr>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Position Of Groove</label>
              <p>{{ pqrAws.position_of_groove ? pqrAws.position_of_groove  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Positions Of Fillet</label>
              <p>{{ pqrAws.position_of_fillet ? pqrAws.position_of_fillet  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Welding Progression</label>
              <p>{{ pqrAws.welding_progression ? pqrAws.welding_progression  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Electrical Charecteristics</h4><hr>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Tungsten Type</label>
              <p>{{ pqrAws.tungsten_type ? pqrAws.tungsten_type  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Tungsten Size</label>
              <p>{{ pqrAws.tungsten_size ? pqrAws.tungsten_size  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Torch Angle</label>
              <p>{{ pqrAws.torch_angle ? pqrAws.torch_angle  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Current</label>
              <p>{{ pqrAws.current ? pqrAws.current  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Model Of Metal Transfer(GMAW)</label>
              <p>{{ pqrAws.mode_of_metal_transfer ? pqrAws.mode_of_metal_transfer  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Remarks</label>
              <p>{{ pqrAws.electrical_char_remark ? pqrAws.electrical_char_remark  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Preheat</h4><hr>
          <v-row >
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Preheat Temperature Min</label>
              <p>{{ pqrAws.preheat_temperature_min ? pqrAws.preheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Preheat Temperature Max</label>
              <p>{{ pqrAws.preheat_temperature_max ? pqrAws.preheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row >
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Interpass Temperature Min</label>
              <p>{{ pqrAws.interpass_temperature_min ? pqrAws.interpass_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Interpass Temperature Max</label>
              <p>{{ pqrAws.interpass_temperature_max ? pqrAws.interpass_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Maintenance</label>
              <p>{{ pqrAws.preheat_maintenance ? pqrAws.preheat_maintenance  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Post Heat Treatment</h4><hr>
          <v-row >
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Postheat Temperature Min</label>
              <p>{{ pqrAws.postheat_temperature_min ? pqrAws.postheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Postheat Temperature Max</label>
              <p>{{ pqrAws.postheat_temperature_max ? pqrAws.postheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row >
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Time Min</label>
              <p>{{ pqrAws.time_min ? pqrAws.time_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Time Max</label>
              <p>{{ pqrAws.time_max ? pqrAws.time_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Remarks</label>
              <p>{{ pqrAws.postheat_remark ? pqrAws.postheat_remark  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Technique</h4><hr>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <label class='view_label'>Oscillation Frequency</label>
          <p>{{ pqrAws.oscillation ? pqrAws.oscillation  : '-' }}</p>
          <label class='view_label'>Weave Bead</label>
          <p>{{ pqrAws.weave_bead ? pqrAws.weave_bead  : '-' }}</p>
          <label class='view_label'>Electrode Spacing</label>
          <p>{{ pqrAws.electrode_spacing ? pqrAws.electrode_spacing  : '-' }}</p>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Interpass / Final Cleaning</label>
              <p>{{ pqrAws.cleaning ? pqrAws.cleaning  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Peening</label>
              <p>{{ pqrAws.peening ? pqrAws.peening  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Weave Width</label>
              <p>{{ pqrAws.weave_width ? pqrAws.weave_width  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Dwell Time</label>
              <p>{{ pqrAws.dwell_time ? pqrAws.dwell_time  : '-' }}</p>
            </v-col>
          </v-row>
          <label class='view_label'>Number Of Electrodes</label>
          <p>{{ pqrAws.electrode ? pqrAws.electrode  : '-' }}</p>
          <label class='view_label'>Multiple Or Single Pass (perside)</label>
          <p>{{ pqrAws.pass_perside ? pqrAws.pass_perside  : '-' }}</p>
          <label class='view_label'>Contact Tube Work Distance</label>
          <p>{{ pqrAws.contact_tube_work_distance ? pqrAws.contact_tube_work_distance  : '-' }}</p>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Welding Parameters</h4><hr>
      <v-row v-for="(wp, ind) in pqrAws.welding_parameter" :key="`wp_${ind}`" class="pt-5">
        <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Welding Process</label>
              <p><v-chip small>{{ wp.wpm_wps_text ? wp.wpm_wps_text  : '-' }}</v-chip></p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Weld Layer</label>
              <p>{{ wp.weld_layer ? wp.weld_layer  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Class</label>
              <p>{{ wp.filler_class ? wp.filler_class  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Size</label>
              <p>{{ wp.filler_size ? wp.filler_size  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Polarity</label>
              <p>{{ wp.wpm_plr_text ? wp.wpm_plr_text  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Current(A)</label>
              <p>{{ wp.min_current ? wp.min_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Current(A)</label>
              <p>{{ wp.max_current ? wp.max_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Voltage(V)</label>
              <p>{{ wp.min_voltage ? wp.min_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Voltage(V)</label>
              <p>{{ wp.max_voltage ? wp.max_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Travel Speed</label>
              <p>{{ wp.min_travel_speed ? wp.min_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Travel Speed</label>
              <p>{{ wp.max_travel_speed ? wp.max_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Feed Speed</label>
              <p>{{ wp.min_feed_speed ? wp.min_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Feed Speed</label>
              <p>{{ wp.max_feed_speed ? wp.max_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Flow Rate</label>
              <p>{{ wp.min_flowrate ? wp.min_flowrate  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Flow Rate</label>
              <p>{{ wp.max_flowrate ? wp.max_flowrate  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="break_page">
        <v-row class="mt-2">
          <v-col :cols="colValue" md="6" sm="12" xs="12">
            <label class='view_label'>Prepared By</label>
            <p>{{ pqrAws.prepared_by ? pqrAws.prepared_by  : '-' }}</p>
            <label class='view_label'>Prepared By Signature</label>
            <p>{{ pqrAws.prepared_by_sign ? pqrAws.prepared_by_sign  : '-' }}</p>
            <label class='view_label'>Date</label>
            <p>{{ pqrAws.prepared_date ? pqrAws.prepared_date  : '-' }}</p>
          </v-col>
          <v-col :cols="colValue" md="6" sm="12" xs="12">
            <label class='view_label'>Approved By</label>
            <p>{{ pqrAws.approved_by ? pqrAws.approved_by  : '-' }}</p>
            <label class='view_label'>Approved By Signature</label>
            <p>{{ pqrAws.approved_by_sign ? pqrAws.approved_by_sign  : '-' }}</p>
            <label class='view_label'>Date</label>
            <p>{{ pqrAws.approved_date ? pqrAws.approved_date  : '-' }}</p>
          </v-col>
          <v-col :cols='colValue' md='4' sm='6' xs='12' >
            <label class='view_label'>Status</label>
            <p>
              <template>
                <v-chip :color="pqrAws.status == 0 ? 'success' : 'warning'" small>{{ pqrAws.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
              </template>
            </p>
          </v-col>
        </v-row>
      </div>
      <v-footer fixed class="d-print-none">
        <v-col class="text-right">
          <v-btn v-if="$checkRight(['edit_welding_procedure'])" color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
          <v-btn color="primary" class="mr-2" @click="print" small v-if="!$vuetify.breakpoint.mdAndDown">Print</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    colValue () {
      return this.$vuetify.breakpoint.mdAndDown ? 12 : undefined
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getWeldingProcedureById/' + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.wptwt_id = res.data.wptwt
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        data.welding_procedure_drawing = res.data.welding_procedure_drawing
        this.pqrAws = data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      pqrAws: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/weldingProcedure/pqrAws/edit/${editId}`, })
    },
    print () {
      window.print()
    }
  }
}
</script>

<style>
.pqrAwsViewForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.pqrAwsViewForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.pqrAwsViewForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
.logo_box {
  border: 1px dotted #ccc;
  max-width: 200px;
}
.upload_container {
  height: auto;
  width: 100%;
}
.pqrAwsViewForm h4 {
  color: #464d69;
  font-weight: bold;
}
.jointDrawings img{
  max-width: 100%;
}
@media print {
  .break_page { page-break-before: always }
}
</style>
